import { useLanguage } from '../LanguageContext';
import translations from '../translate.json';

export type TranslationKey = keyof typeof translations;
export type LanguageCode = 'en' | 'fr';

export const useTranslate = () => {
  const { language } = useLanguage();

  function translate(key: TranslationKey): string {
    if (!translations[key]) {
      console.warn(`Translation key "${key}" not found`);
      return key;
    }

    const translation = translations[key].contents[language];

    if (!translation) {
      console.warn(`Translation "${key}" not found for language "${language}"`);
      return key;
    }
    return translation;
  }

  return { translate };
}